var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconGolden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_249_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V14H12V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_249_8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_249_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V14H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_249_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50812 14H2.49207C2.27899 14.0014 2.07292 13.9167 1.9133 13.762C1.75557 13.6067 1.65758 13.3915 1.63914 13.16L0.853027 4.20001H11.1462L10.3601 13.16C10.3401 13.3895 10.2423 13.6024 10.0859 13.7566C9.92752 13.9135 9.72159 14.0002 9.50812 14ZM8.15306 6.52831C8.03856 6.52803 7.92863 6.57753 7.84739 6.66596C7.76615 6.75439 7.72024 6.87452 7.71972 7.00001V11.2C7.71972 11.326 7.76537 11.4468 7.84664 11.5358C7.92791 11.6249 8.03813 11.6749 8.15306 11.6749C8.26799 11.6749 8.37821 11.6249 8.45948 11.5358C8.54075 11.4468 8.5864 11.326 8.5864 11.2V7.00001C8.58588 6.87452 8.53997 6.75439 8.45873 6.66596C8.37749 6.57753 8.26756 6.52803 8.15306 6.52831ZM5.99911 6.52831C5.88529 6.52916 5.77637 6.57917 5.69598 6.66747C5.61559 6.75578 5.57021 6.87527 5.5697 7.00001V11.2C5.5697 11.326 5.61536 11.4468 5.69662 11.5358C5.77789 11.6249 5.88811 11.6749 6.00304 11.6749C6.11797 11.6749 6.2282 11.6249 6.30946 11.5358C6.39073 11.4468 6.43639 11.326 6.43639 11.2V7.00001C6.43613 6.9376 6.42463 6.87586 6.40254 6.81834C6.38045 6.76081 6.34821 6.70864 6.30767 6.66481C6.26713 6.62098 6.21909 6.58636 6.16631 6.56294C6.11352 6.53951 6.05606 6.52775 5.99911 6.52831ZM3.85892 6.52831C3.74442 6.52803 3.6345 6.57753 3.55326 6.66596C3.47202 6.75439 3.4261 6.87452 3.42558 7.00001V11.2C3.42558 11.326 3.47123 11.4468 3.5525 11.5358C3.63377 11.6249 3.74399 11.6749 3.85892 11.6749C3.97385 11.6749 4.08408 11.6249 4.16534 11.5358C4.24661 11.4468 4.29227 11.326 4.29227 11.2V7.00001C4.29175 6.87471 4.24597 6.75474 4.16494 6.66634C4.08391 6.57794 3.97325 6.52831 3.85892 6.52831Z",
    fill: "#4C6F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1473 1.40003H7.72081V0.928339C7.72081 0.805795 7.69868 0.684463 7.65568 0.571341C7.61268 0.458219 7.54968 0.355547 7.47029 0.269246C7.39091 0.182946 7.29672 0.114725 7.19316 0.0685184C7.08959 0.0223123 6.97871 -0.000964525 6.8669 3.06116e-05H5.14728C5.03555 -0.000821727 4.92477 0.0225605 4.82132 0.0688306C4.71787 0.115101 4.6238 0.183345 4.54452 0.269631C4.46524 0.355917 4.40232 0.45854 4.35938 0.571591C4.31644 0.684642 4.29434 0.805886 4.29434 0.928339V1.40003H0.853139C0.628491 1.40003 0.413045 1.49783 0.254195 1.67193C0.0953445 1.84602 0.00610352 2.08214 0.00610352 2.32834C0.00610352 2.57454 0.0953445 2.81066 0.254195 2.98475C0.413045 3.15884 0.628491 3.25665 0.853139 3.25665H11.1473C11.3719 3.25665 11.5874 3.15884 11.7462 2.98475C11.9051 2.81066 11.9943 2.57454 11.9943 2.32834C11.9943 2.08214 11.9051 1.84602 11.7462 1.67193C11.5874 1.49783 11.3719 1.40003 11.1473 1.40003Z",
    fill: "#4C6F91"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGolden);
export default __webpack_public_path__ + "static/media/delete-icon-golden.8ff3f0bb.svg";
export { ForwardRef as ReactComponent };